import { parseString } from 'xml2js';
export default {
  data() {
    return {
      inputData: '',
      outputResult: ''
    };
  },
  methods: {
    convertJsonToXml() {
      try {
        const json = JSON.parse(this.inputData);
        this.outputResult = this.jsonToXml(json);
      } catch (error) {
        this.outputResult = '无效的 JSON 数据: ' + error.message;
      }
    },
    convertXmlToJson() {
      parseString(this.inputData, {
        explicitArray: false,
        trim: true
      }, (err, result) => {
        if (err) {
          this.outputResult = '无效的 XML 数据: ' + err.message;
        } else {
          this.outputResult = JSON.stringify(result, null, 4);
        }
      });
    },
    jsonToXml(json, indent = 0) {
      let xml = '';
      const indentation = '  '.repeat(indent);
      for (const prop in json) {
        if (Array.isArray(json[prop])) {
          json[prop].forEach(item => {
            xml += `${indentation}<${prop}>\n${this.jsonToXml(item, indent + 1)}${indentation}</${prop}>\n`;
          });
        } else {
          xml += `${indentation}<${prop}>`;
          if (typeof json[prop] === 'object') {
            xml += `\n${this.jsonToXml(json[prop], indent + 1)}${indentation}`;
          } else {
            xml += json[prop];
          }
          xml += `</${prop}>\n`;
        }
      }
      return xml;
    }
  }
};